import React from 'react';
import { useRouter } from 'next/router';

import {
  useTopUnderwritersContext,
} from '@/finsight/application/TopCompanies/topCompaniesContexts/TopUnderwritersContext';

import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';
import LinkTable from '@/finsight/ui/common/components/LinkTable';
import {
  topCompaniesTablesCommonProps,
  getTopCompanyColumns,
} from '../common/tableConfigs';
import { getLeagueTableItemRoute } from '@/finsight/ui/components/league/LeagueTablePage/helpers';
import { getQueryString } from '@/Framework/Router';
import { UNDERWRITER_NAME } from '@/finsight/ui/common/components/TopCompanies/constants';

const TopUnderwriters = () => {
  const {
    query: {
      products,
      regions,
    },
  } = useRouter();
  const search = {
    products,
    regions,
  };
  const {
    collection,
    totalCount,
    page,
    perPage,
    paginate,
    isFetching,
    showVolume,
  } = useTopUnderwritersContext();

  return (
    <>
      { isFetching && <Spinner isVisible overlay /> }
      <LinkTable
        { ...topCompaniesTablesCommonProps }
        columns={ getTopCompanyColumns({
          showVolume,
          companyRole: UNDERWRITER_NAME,
        }) }
        data={ collection }
        page={ page }
        perPage={ perPage }
        totalCount={ totalCount }
        onPageChange={ (page) => paginate(page.selected) }
        isFetching={ isFetching }
        getRoutePath={ getLeagueTableItemRoute(getQueryString(search), UNDERWRITER_NAME) }
        emptyMessageText="No Top Underwriters during the selected period."
        paginatorDataTest="linkTablePaginatorUnderwriters"
        rowDataTest="linkTableRowUnderwriters"
      />
    </>
  );
};

export default TopUnderwriters;
